import config from '../../config/config';

export const MERCHANTS_LOAD = 'MERCHANTS/MERCANTS_LOAD';
export const MERCHANTS_SUCCESS = 'MERCHANTS/MERCANTS_SUCCESS';
export const MERCHANTS_FAILURE = 'MERCHANTS/MERCANTS_FAILURE';

export function getMerchantsFailureActionCreator(error) {
    return {
        error,
        type: MERCHANTS_FAILURE
    };
}

export function getMerchantsSuccessActionCreator(merchants) {
    return {
        merchants,
        type: MERCHANTS_SUCCESS
    };
}

export function getMerchants() {
    return {
        failureActionTypeOrCreator: getMerchantsFailureActionCreator,
        fetchParams: {
            url: `${config.merchantApiUrl}`
        },
        loadActionTypeOrCreator: MERCHANTS_LOAD,
        successActionTypeOrCreator: getMerchantsSuccessActionCreator
    };
}
